import { useSite } from "@/context/SiteContext";
import { useMeta } from "@/lib/useMeta";
import { PageHeader } from "@/components/site/Layout";

export const DigitalEdition = () => {
  const { content } = useSite();
  useMeta("digital");
  return (
    <div data-testid="digital-edition-page">
      <h1 className="sr-only">{content.digital.heading}</h1>
      <iframe
        src={content.digital.flipbook_url}
        title={content.digital.heading}
        className="fp-iframe block"
        style={{ border: "1px solid lightgray", width: "100%", height: `${Number(content.digital.height) || 800}px` }}
        allowFullScreen
        allow="clipboard-write"
        scrolling="no"
        data-testid="flipbook-iframe"
      />
    </div>
  );
};

export const Questionnaire = () => {
  const { content } = useSite();
  useMeta("questionnaire");
  const q = content.questionnaire;
  return (
    <div data-testid="questionnaire-page">
      <PageHeader title={q.heading} />
      <div className="mx-auto px-2 sm:px-6 py-10" style={{ maxWidth: 1048 }}>
        <iframe src={q.form_url} title={q.heading} width="1000" height={Number(q.height) || 5962} frameBorder="0" marginHeight="0" marginWidth="0" className="w-full max-w-[1000px] mx-auto block bg-white" data-testid="questionnaire-iframe">Loading…</iframe>
      </div>
    </div>
  );
};
